$(function () {
    //for the right column content 
    $(".risk-tabs-section.show-graphic-content").each(function () {
        var _this = $(this)
        $(this).find('.risk-tabs__item-data').on('shown.bs.tab', function (e) {
            _this.find(".graphic-content .risk-tabs__tab-pane").removeClass("d-none");
            _this.find(".graphic-content .risk-tabs__tab-pane").hide();
            if (_this.find(`.graphic-content ${$(this).attr("data-target")}`).children().length == 0) {
                _this.find('#mainTabSection').removeClass();
                //added if w-lg-75 class is not available
                if (!_this.find(".risk-tabs__wrapper").hasClass("w-lg-75")) {
                    _this.find(".risk-tabs__wrapper").addClass("w-lg-75");
                }
                if (_this.hasClass("full-width-graphic-tab-content")) {
                    //to check if it is not mobile or tablet layout
                    if ($("body").innerWidth() > 992) {
                        _this.find('#tabSectionWrapper').removeClass();
                        _this.find('#tabSectionWrapper').addClass("container")
                    }
                }
                _this.find('#mainTabSection').addClass("col-12");
            } else {
                //removed if w-lg-75 class is available
                if (_this.find(".risk-tabs__wrapper").hasClass("w-lg-75")) {
                    _this.find(".risk-tabs__wrapper").removeClass("w-lg-75");
                }
                var colClass = _this.find('#mainTabSection').attr("data-main-class");
                if (_this.hasClass("full-width-graphic-tab-content")) {
                    _this.find('#tabSectionWrapper').removeClass();
                    _this.find('#tabSectionWrapper').addClass("custom-container")
                }
                _this.find('#mainTabSection').addClass(colClass);
            }
            _this.find(`.graphic-content ${$(this).attr("data-target")}`).show();
        })
    })

    //To fix a weird iOS Safari rendering bug, where the text color is not rendered. Must test in 2024 and remove if bug fixed by Safari.
    if ((/iPhone|iPad/).test(navigator.userAgent)) {
        $('.risk-tabs__item-data').on('hidden.bs.tab', function (e) {
            const $currentElem = $(this);
            $currentElem.css("visibility", "hidden").removeClass("risk-tabs__item-data");
            window.setTimeout(x => {
                $currentElem.css("visibility", "visible").addClass("risk-tabs__item-data")
            }, 50);
        });
    }

    //check if content is there on the initial load
    $(".risk-tabs-section.show-graphic-content").each(function () {
        var _this = $(this);
        if (_this.find(".graphic-content .tab-pane").first().children().length == 0) {
            _this.find("#mainTabSection").removeClass();
            _this.find("#mainTabSection").addClass("col-lg-12");

            //if "show-graphic-content" class is available and content is not available for the tab, then w-lg-75 will be added through JS
            _this.find(".risk-tabs__wrapper").addClass("w-lg-75");

            //_this.find(".graphic-content").parent().removeClass();
            if (_this.hasClass("full-width-graphic-tab-content")) {
                //to check if it is not mobile or tablet layout
                if ($("body").innerWidth() > 992) {
                    _this.find('#tabSectionWrapper').removeClass();
                    _this.find('#tabSectionWrapper').addClass("container")
                }
            }
        }
    });

    if (typeof PerformanceChartUcitsBlockChartList != "undefined") reflowTheCharts();

    //redraw charts inside tab.
    function reflowTheCharts() {
        PerformanceChartUcitsBlockChartList.forEach(Chart => Chart.reflow());
    }

    $(".risk-tabs__item-data").on("shown.bs.tab", function (e) {
        if (typeof PerformanceChartUcitsBlockChartList != "undefined") reflowTheCharts();
    })

    //to remove the header class if scrolled down on load
    if ($(window).scrollTop() >= 150) {
        $("header.site-header").removeClass("no-drop-shadow");
    }

    //change z-index on share button clicked on top content
    $(".page-top__content .share-widget__toggle-button").on('click', function () {
        $(this).parent().hasClass("show") ? $(".bs4-nav.landing-page-nav").css("z-index", "1") : $(".bs4-nav.landing-page-nav").css("z-index", "9999")
    })

    $('#copyURL').on('click', function () {
        var $temp = $("<input>");
        var $url = $(location).attr('href').split('#')[0];
        $("body").append($temp);
        $temp.val($url).select();
        document.execCommand("copy");
        $temp.remove();
    })

    //youtube video is resetted once the modal is closed
    $('#HeroLandingPage').on('hidden.bs.modal', function () {
        $("#HeroLandingPage iframe").attr("src", $("#HeroLandingPage iframe").attr("src"));
    });

    //multiple factsheets button
    const multipleFactsheets = document.querySelector('.multiple-factsheet-popover');
    if (multipleFactsheets) {
        // popover for multi-product pages to display multiple factsheets if available
        const popoverTemplate = '<div class="mf-popover popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
        $(".multiple-factsheet-popover").each((i, e) => {
            const elementId = $(e).data('elementid');
            const element = document.getElementById(elementId);

            $(e).attr('data-popover-open', 'false');

            $(e).popover({
                content: element,
                html: true,
                template: popoverTemplate,
                container: e.parentNode,
                placement: 'bottom',
                trigger: 'manual'
            });

            $(e).on('show.bs.popover', () => {
                $(e).attr('data-popover-open', 'true');
                element.classList.add('d-flex');
                // increase sticky-header z-index to 5
                if (window.innerWidth > 992) $('#root > .landing-page-nav').addClass('increase-sticky-header-z-index');
            });

            $(e).on('hidden.bs.popover', () => {
                $(e).attr('data-popover-open', 'false');
                element.classList.remove('d-flex');
                // revert sticky-header z-index
                $('#root > .landing-page-nav').removeClass('increase-sticky-header-z-index');
            });

            $(e).on('click', function(event) {
                event.stopPropagation();
                const isVisible = $(this).attr('data-popover-open') === 'true';
                
                $(".multiple-factsheet-popover").not(this).popover('hide');
                
                if (isVisible) {
                    $(this).popover('hide');
                } else {
                    $(this).popover('show');
                }
            });

            $(document).on('click', function(event) {
                if (!$(event.target).closest('.multiple-factsheet-popover, .popover').length) {
                    $(".multiple-factsheet-popover").popover('hide');
                }
            });

            $(document).on('click', '.popover', function(event) {
                event.stopPropagation();
            });

            window.addEventListener('resize', () => {
                if ($('.mf-popover').length > 0 && window.innerWidth > 992) $('#root > .landing-page-nav').addClass('increase-sticky-header-z-index');
                else $('#root > .landing-page-nav').removeClass('increase-sticky-header-z-index');

                setTimeout(() => {
                    $(e).popover('update')
                }, 500);
            });
        });
    }

    //ISIN copy button
    const copyButtons = document.querySelectorAll('.fund-data-row__fund-details span.copy-value-button img');
    if (copyButtons.length > 0) {
        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
        const trigger = isTouchDevice ? "click" : "hover";
        copyButtons.forEach( function(e, k, el) {
            $(e).tooltip({ trigger: trigger });
            e.addEventListener('click', function () {
                $(e).tooltip("dispose");
                var copiedText = $(e).attr("data-copiedtext") ?? "Copied";
                $(e).attr("title", copiedText);
                var data = $(e).attr("data-value");
                navigator.clipboard.writeText(data);
                $(e).tooltip('enable');
                $(e).tooltip('show');
                setTimeout(() => {
                    $(this).tooltip("hide");
                }, 1000);
            });
        });

        window.onload = () => {
            $(copyButtons).tooltip();
        }

        //prevent slick from removing eventlisteners
        $(copyButtons).closest('.carousel-block__main--desktop-ucits').on('breakpoint', () => {
            $(copyButtons).tooltip();
        });

    }
});